var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{staticClass:"pl-2 pr-2"},[_c('v-col',{attrs:{"md":"6"}},[_c('form-ads')],1),_c('v-col',{attrs:{"md":"6"}},[_c('preview-ads')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }